import React from "react";
import "./Premier2.css";

import Premier3 from "../../Images/doubleimage-removebg-preview.png";

const Premier2 = ({handlePopup}) => {
  return (
    <div className="premier-landing-page2">
      <div className="premier-container">
        <div className="premier-content second">
          <div className="premier-image-container">
            <img
              src={Premier3}
              alt="Mobile App Preview"
              className="mobile-preview"
            />
          </div>
          <div className="premier-text-content">
            <span className="premier-badge2">Brand Deals</span>
            <h2 className="premier-secondary-title2">
              Collaborate, Promote, and Earn with Brands{" "}
            </h2>
            <p className="premier-secondary">Your Influence, Their Spotlight</p>

            <ul className="premier-feature-list2">
              <p className="premier-feature-list-p">
                <span className="highlight">Endless Opportunities,</span>{" "}
                Partner with 100+ leading brands like Myntra, H&M, Ajio, and
                more.{" "}
              </p>
              <p className="premier-feature-list-p1">
               
                <span className="highlight">
                  Effortless Campaign Management,
                </span>{" "}
                Get campaigns delivered straight to your dashboard.
              </p>
              <p className="premier-feature-list-p1">
                <span className="highlight">Earn on Every Sale,</span> Unlock
                commissions on every product sold through your Businessbay
                Store.
              </p>
              <p className="premier-feature-list-p1">
                <span className="highlight">Track & Grow,</span> Real-time
                insights to monitor your campaign performance and earnings.
              </p>
            </ul>

            <button className="premier-cta-button2" onClick={handlePopup}>
              Try Businessbay for free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Premier2;
